import React from 'react';
import { FormattedMessage } from 'react-intl';
import { completeAction } from 'domain/router';
import { clearUiDeferredToastsAction } from 'domain/ui/actions';
import { isMatchRoute } from 'domain/router/utils';
import ROUTES_PATH from 'domain/router/routesPathConfig';

import toast from 'components/Toast';

const DEFERRED_TOAST_DELAY = 100;

const isCompanyDefaultRoute = () => {
  return (
    isMatchRoute(ROUTES_PATH.COMPANY_WORKSPACE_CATEGORY_UNDEFINED.absolute) ||
    isMatchRoute(ROUTES_PATH.COMPANY_CONFIDENTIAL_WORKSPACE_CATEGORY_UNDEFINED.absolute)
  );
};

const createFormattedMessage = (messageData) => {
  if (typeof messageData === 'string' || React.isValidElement(messageData)) {
    return messageData;
  }

  if (messageData && typeof messageData === 'object' && messageData.id) {
    const { id, defaultMessage, values } = messageData;

    // Handle nested values that need FormattedMessage
    const processedValues = {};
    if (values) {
      Object.keys(values).forEach((key) => {
        const value = values[key];
        if (value && typeof value === 'object' && value.id) {
          processedValues[key] = (
            <span style={value.style || {}}>
              <FormattedMessage id={value.id} defaultMessage={value.defaultMessage} />
            </span>
          );
        } else {
          processedValues[key] = value;
        }
      });
    }

    return <FormattedMessage id={id} defaultMessage={defaultMessage} values={processedValues} />;
  }

  return messageData;
};

const processDeferredToasts = (store) => {
  const state = store.getState();
  const toastModel = state.ui.toast;
  const hasDeferredToasts = toastModel.deferred?.size > 0;

  if (hasDeferredToasts) {
    toastModel.deferred.forEach((item) => {
      const formattedMessage = createFormattedMessage(item.message);
      toast[item.type](formattedMessage);
    });

    // Add a small delay to ensure the new page is rendered
    setTimeout(() => {
      store.dispatch(clearUiDeferredToastsAction());
    }, DEFERRED_TOAST_DELAY);
  }
};

const deferredToastMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (isCompanyDefaultRoute()) {
    return result;
  }

  // When location changes, process any deferred toasts
  if (action.type === completeAction.type) {
    processDeferredToasts(store);
  }

  return result;
};

export default deferredToastMiddleware;
